import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import ToggleSection from 'zoomforth_component_lib/toggle_section.jsx';


class AskForVisitorInfoToggleSection extends Component {

  render() {
    const {
      onChange,
      areVisitsFromEuAnonymous,
      areVisitsFromCaliforniaAnonymous,
      areVisitsOutsideEuAnonymous
    } = this.props;

    let {
      checked,
      disabled,
      disabledReason
    } = this.props;

    let tooltip = 'If enabled, before visitors see your site they will need to enter their name and email. ' +
      'They will not be asked upon return.';

    let explanation = 'All visitors will be asked for their name and email.';

    if (!checked) {
      explanation = null;
    }

    if (!disabled && checked) {
      // we do not care about informing about privacy if this is disabled for a different reason,
      // or if the toggle is not checked in the first place

      if (areVisitsFromEuAnonymous && areVisitsFromCaliforniaAnonymous && areVisitsOutsideEuAnonymous) {

        disabled = true;
        checked = false;
        disabledReason = 'All visitors are being anonymized for this account, ' +
          'so visitors will never be asked their name nor email.';
        explanation = 'No visitors will be asked for their name of email because of this account\'s privacy settings.';

      } else if (!areVisitsFromEuAnonymous && !areVisitsFromCaliforniaAnonymous && !areVisitsOutsideEuAnonymous) {

        explanation = 'All visitors will be asked for their name and email';

      } else {

        explanation = (
          <div>
            {
              areVisitsFromEuAnonymous &&
                <Fragment>
                  EU visitors will be anonymized, according to this account's privacy settings.<br />
                </Fragment>
            }

            {
              areVisitsFromCaliforniaAnonymous &&
                <Fragment>
                  California visitors will be anonymized, according to this account's privacy settings.<br />
                </Fragment>
            }

            {
              areVisitsOutsideEuAnonymous ?
                'Other visitors will anonymized, according to this account\'s privacy settings.'
              :
                'Other visitors will be asked for their name and email.'
            }
          </div>
        );
      }

    }

    return (
      <ToggleSection 
        name="Ask Visitors For Name/Email" 
        tooltip={tooltip}
        explanation={explanation}
        checked={checked} 
        onChange={onChange} 
        disabled={disabled} 
        disabledReason={disabledReason} 
      />
    );
  }

}

AskForVisitorInfoToggleSection.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  areVisitsFromEuAnonymous: PropTypes.bool,
  areVisitsOutsideEuAnonymous: PropTypes.bool
};

export default AskForVisitorInfoToggleSection;
